import React from 'react';

import { Alert, Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';

import type { CopySectionDetails } from './copyFromPreviousModel';

type CopySectionOptionProps = {
  checked: boolean;
  details?: CopySectionDetails;
  disabledReason?: string;
  label: string;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function CopySectionOption({
  checked,
  details,
  disabledReason,
  label,
  name,
  onChange,
}: CopySectionOptionProps) {
  const shown = checked ? details : undefined;

  return (
    <Box>
      <FormControlLabel
        control={<Checkbox checked={checked} name={name} onChange={onChange} size="small" />}
        disabled={!!disabledReason}
        label={
          <Stack>
            <Typography variant="body2">{label}</Typography>
            {disabledReason && (
              <Typography color="text.secondary" variant="caption">
                {disabledReason}
              </Typography>
            )}
            {shown?.summary && (
              <Typography color="text.secondary" variant="caption">
                {shown.summary}
              </Typography>
            )}
          </Stack>
        }
      />

      {shown?.emptyMessage && (
        <Alert severity={shown.emptySeverity ?? 'error'} sx={{ ml: 4, mb: 1 }}>
          {shown.emptyMessage}
        </Alert>
      )}

      {shown && shown.notes.length > 0 && (
        <Alert
          severity={shown.notes.some((note) => note.severity === 'warning') ? 'warning' : 'info'}
          sx={{ ml: 4, mb: 1 }}
        >
          <Box component="ul" sx={{ m: 0, pl: 2 }}>
            {shown.notes.map((note) => (
              <li key={note.text}>{note.text}</li>
            ))}
          </Box>
        </Alert>
      )}
    </Box>
  );
}
